export var NotificationType;
(function (NotificationType) {
    NotificationType["MOMENT_LAUNCHED"] = "MOMENT_LAUNCHED";
    NotificationType["SUBMISSION_RECEIVED"] = "SUBMISSION_RECEIVED";
    NotificationType["SUBMISSION_APPROVED"] = "SUBMISSION_APPROVED";
    NotificationType["REWARD_CLAIMED"] = "REWARD_CLAIMED";
    NotificationType["REWARD_FULFILLED"] = "REWARD_FULFILLED";
})(NotificationType || (NotificationType = {}));
